<template>
  <div class="card">
    <div class="card__head">
      <span class="card__title">门店基础资料</span>
      <span class="card__hint">点击任一材料查看或上传</span>
    </div>
    <div class="doc-grid">
      <button
        v-for="doc in documentTypes"
        :key="doc.type"
        class="doc-item"
        @click="$emit('view-document', doc)"
      >
        <span class="doc-item__name">{{ doc.name }}</span>
        <span class="doc-item__count">{{ countOf(doc.type) }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreDocumentTab',
  props: {
    documentTypes: { type: Array, default: () => [] },
    documentFiles: { type: Object, default: () => ({}) }
  },
  emits: ['view-document'],
  setup(props) {
    const countOf = (type) => {
      const files = props.documentFiles?.[type]
      return Array.isArray(files) && files.length ? `${files.length} 个文件` : '未上传'
    }
    return { countOf }
  }
}
</script>

<style scoped>
.card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  padding: 14px 16px;
}

.card__head {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.card__title {
  font-size: 14px;
  font-weight: 500;
}

.card__hint {
  margin-left: auto;
  font-size: 12px;
  color: var(--text-tertiary);
}

.doc-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 10px;
}

.doc-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 13px;
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  background: var(--bg-card);
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color var(--dur-fast) var(--ease), background var(--dur-fast) var(--ease);
}

.doc-item:hover {
  border-color: var(--brand-500);
  background: var(--bg-selected);
}

.doc-item__name {
  font-size: 13px;
  color: var(--text-primary);
}

.doc-item__count {
  margin-left: auto;
  font-size: 11px;
  color: var(--text-tertiary);
  white-space: nowrap;
}
</style>
